import React, {
  FunctionComponent,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import {
  downloadDataAsExcel,
  printDataAsTable,
  SheetHeaderDisplay,
} from '../../../utils';
import {
  Row as BSRow,
  Dropdown,
  DropdownButton,
  Col,
  FormCheck,
} from 'react-bootstrap';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
} from '../../../components';
import {
  StudentGradeNoSeat,
  SundryExamDate,
  PHISundry,
  UserInfo,
} from '../../../model';
import apis from '../../../apis';
import { useHistory } from 'react-router';
import { DateTime } from 'luxon';
import { GradeSem } from '../../../layouts';
import { toast } from 'react-toastify';

type ChildRender = (classSem: GradeSem) => ReactElement;

type OwnProps = {
  children: ReactNode | ChildRender;
  onGradesLoaded?: () => void;
  onGradeChanged?: (
    year: number,
    sem: number,
    classId?: string
  ) => void;
};

const mapState = (
  state: ApplicationState,
  ownProps: OwnProps
) => ({
  ...state.auth,
  ...ownProps,
});

const mapDispatches = ErrorDispatches;

const connector = connect(
  mapState,
  mapDispatches
);

type Props =
  ConnectedProps<typeof connector>;

const checkKind = [
  {
    Id: 1,
    Checks: '心臟病篩檢',
  },
  {
    Id: 2,
    Checks: '胸部X光',
  },
  {
    Id: 3,
    Checks: '肝功能',
  },
  {
    Id: 4,
    Checks: '腎功能',
  },
  {
    Id: 5,
    Checks: '蛔蟲',
  },
  {
    Id: 6,
    Checks: '蟯蟲',
  },
  {
    Id: 7,
    Checks: 'A型肝炎',
  },
  {
    Id: 8,
    Checks: 'B型肝炎',
  },
  {
    Id: 9,
    Checks: '結核菌素測驗',
  },
  {
    Id: 10,
    Checks: '頭蝨',
  },
  {
    Id: 11,
    Checks: '尿液',
  },
  {
    Id: 12,
    Checks: '心電圖',
  },
  {
    Id: 13,
    Checks: '心臟超音波',
  },
];

const SundryResultCode = [
  '初檢無異狀',
  '初檢異常',
  '複診無異狀',
  '複診異常',
];

const checkTempRep: FunctionComponent<Props> = ({
  user,
  loading,
  catchErrorForModal,
}) => {
  if (loading) {
    useHistory().go(0);

    return <></>;
  }

  type MetricPageData =
    StudentGradeNoSeat &
    PHISundry;

  type ExamDate =
    SundryExamDate;

  const {
    currentSemester = '',
    semesters = {},
  } = user || {};

  const [currentSem] =
    useState(currentSemester);

  const [sundryId, setSundryId] =
    useState<number>();

  const [examDates, setExamDate] =
    useState<ExamDate[]>([]);

  const [
    showExamDate,
    setShowExamDate,
  ] = useState<string>();

  const [
    radioAction,
    setRadioAction,
  ] = useState<string>('All');

  const {
    year = -1,
    sem = -1,
  } = semesters[currentSem];

  const [students, setStudent] =
    useState<MetricPageData[]>([]);

  const [userinfo, setUser] =
    useState<UserInfo>();

  const displayHeader: (
    SheetHeaderDisplay<MetricPageData> &
    HeaderDisplayKeysWithType<MetricPageData>
  )[] = [
      {
        display: '年級',
        property: 'grade',

        onRender: (
          value: unknown
        ) => {
          if (
            typeof value ===
            'number'
          ) {
            return value === 0
              ? ''
              : value;
          }

          return value;
        },

        onSheetRender: (
          value: unknown
        ) => {
          if (
            typeof value ===
            'number'
          ) {
            return value > 100
              ? value - 100
              : value;
          }

          return value as string;
        },
      },

      {
        display: '班級',
        property: 'no',

        onRender: (
          value: unknown
        ) => {
          if (
            typeof value ===
            'number'
          ) {
            return value > 100
              ? value - 100
              : value;
          }

          return value;
        },

        onSheetRender: (
          value: unknown
        ) => {
          if (
            typeof value ===
            'number'
          ) {
            return value > 100
              ? value - 100
              : value;
          }

          return value as string;
        },
      },

      {
        display: '座號',
        property: 'seat',
      },

      {
        display: '學生',
        property: 'name',
      },

      {
        display: '檢查項目',
        property: 'sundryId',

        onRender: (
          value: unknown
        ) => {
          if (value) {
            return typeof value ===
              'number'
              ? checkKind[
                value - 1
              ].Checks
              : '無檢查項目';
          }

          return '';
        },

        onSheetRender: (
          value
        ) => {
          return typeof value ===
            'number'
            ? checkKind[
              value - 1
            ].Checks
            : (value as string);
        },
      },

      {
        property: 'examDate',
        display: '測量日',

        onRender: (
          value: unknown
        ) => {
          return value instanceof
            DateTime
            ? value.toFormat(
              'yyyy/MM/dd'
            )
            : null;
        },

        onSheetRender: (
          value
        ) => {
          return value instanceof
            DateTime
            ? value.toFormat(
              'yyyy/MM/dd'
            )
            : '';
        },
      },

      {
        display: '檢查單位',
        property: 'agencies',
      },

      {
        display: '結果',
        property: 'sundryResult',

        onRender: (
          value: unknown
        ) => {
          return typeof value ===
            'number'
            ? SundryResultCode[
            value
            ]
            : '無結果';
        },

        onSheetRender: (
          value
        ) => {
          return typeof value ===
            'number'
            ? SundryResultCode[
            value
            ]
            : (value as string);
        },
      },

      {
        display: '複檢診斷',
        property:
          'followUpDescription',
      },

      {
        display: '備註',
        property: 'remark',
      },
    ];

  useEffect(() => {
    if (sundryId) {
      apis
        .getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(
          catchErrorForModal
        );

      toast
        .promise(
          apis
            .getSundryExamDateBySundryId(
              year,
              sem,
              sundryId
            )
            .then((r) => {
              setExamDate(r);
              setShowExamDate('');
            }),
          {
            pending:
              '資料載入中......',
            success:
              '資料載入成功！',
            error:
              '資料載入失敗！請查看錯誤資訊。',
          }
        )
        .catch(
          catchErrorForModal
        );
    }
  }, [sundryId]);

  useEffect(() => {
    getCheckTempList();
  }, [
    sundryId,
    showExamDate,
    radioAction,
  ]);

  function getCheckTempList() {
    if (
      sundryId &&
      showExamDate
    ) {
      apis
        .getSundryList(
          year,
          sem,
          sundryId,
          showExamDate,
          radioAction
        )
        .then((s) => {
          setStudent(
            s.map(
              ({
                sundry,
                ...m
              }) => ({
                ...sundry,
                ...m,
              })
            )
          );
        })
        .catch(
          catchErrorForModal
        );
    }
  }

  const title =
    `${year}學年${sem}學期_` +
    `${sundryId
      ? checkKind[
        sundryId - 1
      ].Checks
      : ''}` +
    `檢查清單` +
    `${showExamDate?.replace(
      /\//g,
      ''
    ) ?? ''}`;

  return (
    <AuthedLayout>
      <BSRow className="align-items-center mb-3">
        <Col className="d-flex align-items-center">
          檢查項目：
          <DropdownButton
            title={
              sundryId
                ? checkKind[
                  sundryId - 1
                ].Checks
                : '檢查項目'
            }
            onSelect={(c) => {
              if (c) {
                setSundryId(
                  parseInt(c)
                );
              }
            }}
          >
            {checkKind.map(
              (item) => (
                <Dropdown.Item
                  key={`check-${item.Id}`}
                  eventKey={
                    item.Id
                  }
                >
                  {
                    item.Checks
                  }
                </Dropdown.Item>
              )
            )}
          </DropdownButton>
        </Col>

        <Col className="d-flex align-items-center">
          檢查日期：
          <DropdownButton
            className="mr-2"
            title={
              showExamDate ||
              '檢查日期'
            }
            onSelect={(g) => {
              if (g) {
                setShowExamDate(
                  g
                );
              }
            }}
          >
            {examDates.length ? (
              [...examDates]
                .sort(
                  (
                    a,
                    b
                  ) =>
                    (
                      b.examDate
                        ?.toMillis?.() ??
                      0
                    ) -
                    (
                      a.examDate
                        ?.toMillis?.() ??
                      0
                    )
                )
                .map(
                  (
                    date,
                    idx
                  ) => (
                    <Dropdown.Item
                      key={`date-${idx}`}
                      eventKey={
                        date.examDate?.toFormat(
                          'yyyy/MM/dd'
                        )
                      }
                    >
                      {date.examDate?.toFormat(
                        'yyyy/MM/dd'
                      )}
                    </Dropdown.Item>
                  )
                )
            ) : (
              <Dropdown.Item
                key="date-0"
                eventKey={0}
                disabled
              >
                無檢查紀錄
              </Dropdown.Item>
            )}
          </DropdownButton>
        </Col>

        <Col className="d-flex align-items-center">
          <FormCheck
            className="mr-2"
            value="Problem"
            type="radio"
            label="異常清單"
            name="list-action"
            checked={
              radioAction ===
              'Problem'
            }
            onChange={() => {
              setRadioAction(
                'Problem'
              );
            }}
          />

          <FormCheck
            className="mr-2"
            value="All"
            type="radio"
            label="受檢清單"
            name="list-action"
            checked={
              radioAction ===
              'All'
            }
            onChange={() => {
              setRadioAction(
                'All'
              );
            }}
          />
        </Col>

        <div className="text-right">
          <DropdownButton
            id="check-temp-rep-export"
            title="匯出"
            variant="success"
            disabled={
              !students.length
            }
          >
            <Dropdown.Item
              onClick={() => {
                downloadDataAsExcel({
                  title,
                  values:
                    students,
                  headers:
                    displayHeader,
                  footer:
                    '承辦人:                組長:                主任:                校長:                ',
                  exportfile:
                    userinfo
                      ?.exportFileType,
                });
              }}
            >
              Excel 下載
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => {
                printDataAsTable({
                  title,
                  values:
                    students,
                  headers:
                    displayHeader,
                  footer:
                    '承辦人:                組長:                主任:                校長:                ',
                });
              }}
            >
              列印
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </BSRow>

      <hr />

      <BSRow>
        <EditableTableDiv
          values={students}
          headers={displayHeader}
        />
      </BSRow>
    </AuthedLayout>
  );
};

export const CheckTempRep =
  connector(checkTempRep);